import { render, staticRenderFns } from "./imageBlockBottom.vue?vue&type=template&id=445ae412&"
import script from "./imageBlockBottom.vue?vue&type=script&lang=js&"
export * from "./imageBlockBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports